module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "activity-order p-3 d-flex flex-column justify-content-between"
  }, [_c('div', {
    staticClass: "activity-order_body"
  }, [(_vm.activity.requirements_description) ? [_c('p', {
    staticClass: "order_add mb-1"
  }, [_vm._v("Перед зачислением в группу необходимо:")]), _c('p', {
    staticClass: "order_text mb-1"
  }, [_vm._v(_vm._s(_vm.activity.requirements_description))])] : _vm._e(), (_vm.activity.links) ? [_c('p', {
    staticClass: "bold"
  }, [_vm._v("Ссылки")]), (_vm.activity.links) ? _c('ol', {
    staticClass: "links mb-1"
  }, _vm._l((_vm.activity.links), function(link, index) {
    return _c('li', {
      key: index
    }, [_c('a', {
      staticClass: "link",
      attrs: {
        "target": "_blank",
        "href": link.link
      }
    }, [_vm._v(_vm._s(link.comment || link.link))])])
  }), 0) : _vm._e()] : _vm._e(), (_vm.activity.files) ? [_c('p', {
    staticClass: "bold"
  }, [_vm._v("Файлы")]), (_vm.activity.files) ? _c('ol', {
    staticClass: "links mb-1"
  }, _vm._l((_vm.activity.files), function(file) {
    return _c('li', {
      key: file.id
    }, [_c('a', {
      staticClass: "link",
      attrs: {
        "target": "_blank",
        "href": file.file.url
      }
    }, [_vm._v(_vm._s(file.name || file.file.url))])])
  }), 0) : _vm._e()] : _vm._e()], 2), _c('p', {
    staticClass: "order_add"
  }, [_vm._v("Ответ:")]), _c('Textarea', {
    attrs: {
      "maxlength": 500
    },
    model: {
      value: (_vm.answer),
      callback: function($$v) {
        _vm.answer = $$v
      },
      expression: "answer"
    }
  }), _c('File', {
    staticClass: "file",
    attrs: {
      "fileName": _vm.file ? _vm.file.name : "",
      "text": "Файл jpeg, png, gif, pdf, word",
      "error-text": "Приложите файл",
      "warnings": _vm.fileWarnings
    },
    on: {
      "changeInput": _vm.inputFile
    }
  }), _c('div', {
    staticClass: "activity-order_footer d-flex justify-content-end"
  }, [_c('AppButtonNew', {
    attrs: {
      "call-back-fn": _vm.onSubmit
    }
  }, [_vm._v("Подтвердить")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02ccf0d3","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ordersProcessForms/event/components/RequestRequirements.vue
// module id = 91452a591a5363783f34
// module chunks = 6